import { createLifecycleFor } from 'actions/account/collections';
import { TYPE } from 'reducers/account/customEvents';

export const { callApi, send, append, resolve, reject, patterns } =
  createLifecycleFor(TYPE);
